import { Eye, Download } from "lucide-react";
import { API } from "../../App";

// Ver (abre numa nova aba) e descarregar uma cópia de um documento carregado. Só o dono do documento consegue.
export default function DocumentoAcoes({ docId }) {
  if (!docId) return null;
  const url = `${API}/di/documents/me/anexos/${docId}/download`;
  return (
    <span className="ml-2 inline-flex items-center gap-2 align-middle">
      <a href={url} target="_blank" rel="noreferrer" title="Ver" aria-label="Ver documento" className="text-sky-300 hover:text-sky-200" data-testid="documento-ver">
        <Eye className="w-4 h-4" />
      </a>
      <a href={url} download title="Descarregar" aria-label="Descarregar documento" className="text-sky-300 hover:text-sky-200" data-testid="documento-descarregar">
        <Download className="w-4 h-4" />
      </a>
    </span>
  );
}
